















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { userInviteGetRewardList } from '@/api'
import moment from 'moment'
@Component({
  name: 'GoldenbeanHarvest',
  filters: {
    dateFormat: (value: any, pattern: any) => {
      return moment(value).format(pattern)
    }
  }
})
export default class GoldenbeanHarvest extends Vue {
  [x: string]: any
  list: any = []
  language!: string
  emptyImage = require('@/assets/Empty_NoData.png')

  created() {
    this.language = (this.$route.query.language as string) || 'ug'
    this.getObtainDetailList()
  }
  // 返回
  handelBack() {
    this.$router.push(`/invite?language=${this.language}`)
  }
  dateFormat(value: string | number | Date, pattern: string): string {
    return moment(value).format(pattern)
  }
  async getObtainDetailList() {
    const { data, code } = await userInviteGetRewardList()
    if (code == 1001 && data) {
      this.list = data
      console.log(data, '///')
    }
  }
}
